import React, { ReactNode } from 'react';
import { InfoIcon } from '../../../ui';

interface ITooltipInfoIconProps {
    children: ReactNode | ReactNode[];
    testId?: string;
}

const TooltipInfoIcon = ({ children, testId }: ITooltipInfoIconProps) => {
    return <InfoIcon testId={testId}>{children}</InfoIcon>
}

export default TooltipInfoIcon;